import IncubatorContainer from "./IncubatorContainer";

export default IncubatorContainer;
